import Link from "next/link";
import React from "react";

enum PaymentTypeEnum {
  CREDIT_CARD = "card",
  CASH_APP = "cashapp",
  APP_PAY = "apple_pay",
  GOOGLE_PAY = "google_pay",
}

const CreditCardPolicy = ({ amount }: { amount: string }) => (
  <div className="mt-2 text-base w-full max-w-md text-gray-500">
    <b>
      By selecting “Subscribe”, I agree to Punchup’s{" "}
      <Link
        href="/tos"
        className="text-blue-600 hover:text-blue-600 font-small underline"
      >
        Terms of Service
      </Link>{" "}
      and{" "}
      <Link
        href="/privacy"
        className="text-blue-600 hover:text-blue-600 font-small underline"
      >
        Privacy Policy
      </Link>{" "}
      and that I will be charged ${amount} today and automatically each month
      thereafter until I cancel. I can cancel on my{" "}
      <Link
        href="/profile"
        className="text-blue-600 hover:text-blue-600 font-small underline"
      >
        Punchup Account page
      </Link>{" "}
      prior to the start of any future billing periods to avoid future charges.
      No refunds or credits for partial subscription periods unless required by
      law.
    </b>
  </div>
);

const CashAppPolicy = ({ amount }: { amount: string }) => (
  <div className="mt-2 text-base w-full max-w-md text-gray-500">
    <b>
      By selecting “Subscribe”, I agree to Punchup’s{" "}
      <Link
        href="/tos"
        className="text-blue-600 hover:text-blue-600 font-small underline"
      >
        Terms of Service
      </Link>{" "}
      and{" "}
      <Link
        href="/privacy"
        className="text-blue-600 hover:text-blue-600 font-small underline"
      >
        Privacy Policy
      </Link>{" "}
      and that Punchup may debit my Cash App account for ${amount} today and
      automatically each month thereafter until I cancel. I can cancel on my{" "}
      <Link
        href="/profile"
        className="text-blue-600 hover:text-blue-600 font-small underline"
      >
        Punchup Account page
      </Link>{" "}
      page prior to the start of any future billing periods to avoid future
      charges. No refunds or credits for partial subscription periods unless
      required by law.
    </b>
  </div>
);

const ApplePayPolicy = ({ amount }: { amount: string }) => (
  <div className="mt-2 text-base w-full max-w-md text-gray-500">
    <b>
      By selecting “Subscribe”, I agree to Punchup’s{" "}
      <Link
        href="/tos"
        className="text-blue-600 hover:text-blue-600 font-small underline"
      >
        Terms of Service
      </Link>{" "}
      and{" "}
      <Link
        href="/privacy"
        className="text-blue-600 hover:text-blue-600 font-small underline"
      >
        Privacy Policy
      </Link>{" "}
      and that I will be charged ${amount} today and automatically each month
      thereafter until I cancel. I can cancel on my{" "}
      <Link
        href="/profile"
        className="text-blue-600 hover:text-blue-600 font-small underline"
      >
        Punchup Account page
      </Link>{" "}
      prior to the start of any future billing periods to avoid future charges.
      No refunds or credits for partial subscription periods unless required by
      law.
    </b>
  </div>
);

const GooglePayPolicy = ({ amount }: { amount: string }) => (
  <div className="mt-2 text-base w-full max-w-md text-gray-500">
    <b>
      By selecting “Subscribe”, I agree to Punchup’s{" "}
      <Link
        href="/tos"
        className="text-blue-600 hover:text-blue-600 font-small underline"
      >
        Terms of Service
      </Link>{" "}
      and{" "}
      <Link
        href="/privacy"
        className="text-blue-600 hover:text-blue-600 font-small underline"
      >
        Privacy Policy
      </Link>{" "}
      and that I will be charged ${amount} today and automatically each month
      thereafter until I cancel. I can cancel on my{" "}
      <Link
        href="/profile"
        className="text-blue-600 hover:text-blue-600 font-small underline"
      >
        Punchup Account page
      </Link>{" "}
      prior to the start of any future billing periods to avoid future charges.
      No refunds or credits for partial subscription periods unless required by
      law.
    </b>
  </div>
);

export default function SubscriptionPaymentPolicyFooter({
  amount,
  paymentType,
  className,
}: {
  amount: string;
  paymentType: string;
  className?: string;
}) {
  const renderPolicyComponent = (type: PaymentTypeEnum) => {
    switch (type) {
      case PaymentTypeEnum.CREDIT_CARD:
        return (
          <div className={className}>
            <CreditCardPolicy amount={amount} />
          </div>
        );
      case PaymentTypeEnum.CASH_APP:
        return (
          <div className={className}>
            <CashAppPolicy amount={amount} />
          </div>
        );
      case PaymentTypeEnum.APP_PAY:
        return (
          <div className={className}>
            <ApplePayPolicy amount={amount} />
          </div>
        );
      case PaymentTypeEnum.GOOGLE_PAY:
        return (
          <div className={className}>
            <GooglePayPolicy amount={amount} />
          </div>
        );
      default:
        return (
          <div className={className}>
            <CreditCardPolicy amount={amount} />
          </div>
        );
    }
  };

  return renderPolicyComponent(paymentType as PaymentTypeEnum);
}
